import { normalizeWorkspace } from 'lib/analytics'
import { getPlan } from 'lib/utils/billing'

/**
 * Exports.
 */

export function settingsPage (workspace) {
  window.analytics.page('Workspace Settings', normalizeWorkspace(workspace))
}

export function settingsBasicLinkClicked (workspace) {
  window.analytics.track('Settings Workspace Information Clicked', normalizeWorkspace(workspace))
}

export function settingsNotificationsLinkClicked (workspace) {
  window.analytics.track('Settings Notifications Clicked', normalizeWorkspace(workspace))
}

export function settingsTeamLinkClicked (workspace) {
  window.analytics.track('Settings Team Members Clicked', normalizeWorkspace(workspace))
}

export function settingsPaymentHistoryLinkClicked (workspace) {
  window.analytics.track('Settings Payment History Clicked', normalizeWorkspace(workspace))
}

export function settingsReceiptLinkClicked (workspace) {
  window.analytics.track('Settings Receipt Information Clicked', normalizeWorkspace(workspace))
}

export function settingsChangePlanButtonClicked (workspace, billing, nextPlan) {
  const oldPlan = getPlan(workspace)

  window.analytics.track('Subscription Plan Clicked', {
    ...normalizeWorkspace(workspace),
    workspace_has_card: Boolean(billing.card),
    old_plan_name: oldPlan.name,
    old_plan_amount: oldPlan.amount,
    old_plan_interval: oldPlan.interval,
    new_plan_name: nextPlan.name,
    new_plan_amount: nextPlan.amount,
    new_plan_interval: nextPlan.interval
  })
}

export function settingsCTAClicked ({ workspace, href, text, style, location }) {
  window.analytics.track('CTA Clicked', {
    ...normalizeWorkspace(workspace),
    cta_href: href,
    cta_text: text,
    cta_style: style,
    cta_location: location,
    public: false
  })
}

export function settingsNotificationsSaved (workspace, settings) {
  let props = normalizeWorkspace(workspace)

  // adds props for each type (eg: "integrations", "warehouses", "sources")
  Object.keys(settings.subscribers).forEach((type) => {
    let list = settings.subscribers[type]
    props[`${type}Count`] = list.length
    props[`${type}Emails`] = list.join(',')
  })

  window.analytics.track('Notification Settings Saved', props)
}

export function settingsReceiptSaved (workspace) {
  window.analytics.track('Settings Receipt Information Saved', normalizeWorkspace(workspace))
}

export function surveyViewed (surveyType, workspace) {
  window.analytics.track('Survey Viewed', {
    ...normalizeWorkspace(workspace),
    survey_name: 'Workspace Churn Survey',
    survey_medium: 'in-app',
    survey_tool: 'in-app',
    survey_type: surveyType
  })
}

export function surveySubmitted (surveyType, workspace, survey) {
  const timeElapsed = (new Date().getTime() - survey.timestamp) / 1000
  window.analytics.track('Survey Completed', {
    ...normalizeWorkspace(workspace),
    survey_name: 'Workspace Churn Survey',
    survey_medium: 'in-app',
    survey_tool: 'in-app',
    survey_type: surveyType,
    survey_time_elapsed: timeElapsed,  // seconds
    survey_other_feedback: survey.other,
    survey_primary_label: survey.parentValue,
    survey_primary_value: survey.parentLabel,
    survey_secondary_label: survey.childValue,
    survey_secondary_value: survey.childLabel
  })
}

export function surveyClosed (surveyType, workspace, survey) {
  const timeElapsed = (new Date().getTime() - survey.timestamp) / 1000
  window.analytics.track('Survey Closed', {
    ...normalizeWorkspace(workspace),
    survey_name: 'Workspace Churn Survey',
    survey_medium: 'in-app',
    survey_tool: 'in-app',
    survey_type: surveyType,
    survey_time_elapsed: timeElapsed, // seconds
    survey_other_feedback: survey.other,
    survey_primary_label: survey.parentValue,
    survey_primary_value: survey.parentLabel,
    survey_secondary_label: survey.childValue,
    survey_secondary_value: survey.childLabel
  })
}



// WEBPACK FOOTER //
// ./pages/workspace-settings/analytics/index.js